import React, { type FunctionComponent, Suspense } from 'react'
import { RouteSuspenseLoading } from 'legacy/dash-components/route-suspense/components/RouteSuspenseLoading'

export const RouteSuspense: FunctionComponent = ({ children }) => (
  <Suspense fallback={<RouteSuspenseLoading />}>{children}</Suspense>
)
